export default "__VITE_ASSET__C$ODiK41__"